import React, { useState, useEffect, useCallback } from "react";
import SearchBar from "./SearchBar";
import { defaultGridProps } from "../../../components/AuiGrid/gridLayout";
import ButtonBar from "../../../components/Layout/ButtonBar";
import { useAxiosWithAuthorization } from "../../../utils/api";
import { ModalConfirm } from "../../../components/Confirm";
import useAuiGridMethods from "../../../hooks/AuiGrid/useAuiGridMethods";
import {
  createAuthColumnData,
  createMenuColumnData,
  createMenuAuthColumnData,
} from "./conlumnLayout";

import { useId } from "react-id-generator";
import { saveGridCheckData } from "../../../utils/validators";

const AuthMenuMng = (props) => {
  const [authGrid] = useId(1, "aui-grid-");
  const [menuAuthGrid] = useId(1, "aui-grid-");
  const [menuGrid] = useId(1, "aui-grid-");

  let auiAuthGrid = useAuiGridMethods(authGrid);
  let auiMenuAuthGrid = useAuiGridMethods(menuAuthGrid);
  let auiMenuGrid = useAuiGridMethods(menuGrid);

  //그리드 초기 설정
  useEffect(() => {
    auiAuthGrid.create(createAuthColumnData(), {
      ...defaultGridProps,
    });
    auiMenuAuthGrid.create(createMenuAuthColumnData(), {
      ...defaultGridProps,
      editable: true,
    });
    auiMenuGrid.create(createMenuColumnData(), {
      ...defaultGridProps,
    });

    auiAuthGrid.bind("cellClick", function (event) {
      searchAuthMenuList(event.item.authId);
    });

    // 에디팅 시작 이벤트 바인딩
    auiMenuAuthGrid.bind("cellEditBegin", function (event) {
      // 추가된 행 아이템들(배열)은 수정이 가능해야
      if (auiMenuAuthGrid.isAddedById(event.item._$uid)) {
        return true;
      }
      // 디테일 그리드의 디테일코드 편집 불가능
      if (event.menuId === "menuId" || event.menuNmKor === "menuNmKor") {
        return false;
      }
    });

    handleMenuSearch();
  }, []);

  const [primaryParameters, setPrimaryParameters] = useState({
    schAuthId: "",
    schAuthNm: "",
  });
  //권한정보 검색 URL
  const SERARCH_AUTH_URL = "/common/auth/searchAuthList.do";
  //권한별메뉴정보 검색 URL
  const SERARCH_AUTH_MENU_URL = "/common/auth/searchAuthMenuList.do";
  //권한별메뉴정보 저장 URL
  const SAVE_AUTH_MENU_URL = "/common/auth/saveAuthMenuList.do";
  //권한별메뉴정보 삭제 URL
  const DELETE_AUTH_MENU_URL = "/common/auth/deleteAuthMenuList.do";
  //메뉴정보 검색 URL
  const SERARCH_MENU_URL = "/common/menu/searchMenuList.do";

  const [, fetchData] = useAxiosWithAuthorization(
    {
      url: SERARCH_AUTH_URL,
    },
    { manual: true }
  );

  const [menuFieldValues, setMenuFieldValues] = useState({
    schMenuId: "",
    schMenuNmKor: "",
  });

  const handleMenuSearch = async () => {
    const {
      data: { data },
    } = await fetchData({
      url: SERARCH_MENU_URL,
      params: menuFieldValues,
    });

    auiMenuGrid.setGridData(data);
  };

  const handleMasterSearch = async () => {
    const {
      data: { data },
    } = await fetchData({
      url: SERARCH_AUTH_URL,
      params: primaryParameters,
    });
    auiAuthGrid.setGridData(data);
  };

  const searchAuthMenuList = async (authId) => {
    const {
      data: { data },
    } = await fetchData({
      url: SERARCH_AUTH_MENU_URL,
      params: { schAuthId: authId },
    });

    auiMenuAuthGrid.setGridData(data);
  };

  const handleMasterDelete = async () => {
    auiMenuAuthGrid.removeRow("selectedIndex");
  };
  const handleMasterSave = async () => {
    if (
      await ModalConfirm({
        title: "저장",
        description: "데이터를 저장하시겠습니까?",
      })
    ) {
      const addItems = auiMenuAuthGrid.getAddedRowItems();
      const editItems = auiMenuAuthGrid.getEditedRowItems();
      const removeItems = auiMenuAuthGrid.getRemovedItems();

      let param = saveGridCheckData(addItems, editItems, removeItems);

      const {
        data: { data },
      } = await fetchData({
        url: SAVE_AUTH_MENU_URL,
        data: param,
        method: "POST",
      });

      const authItem = auiAuthGrid.getSelectedItems()[0].item;

      searchAuthMenuList(authItem.authId);
    }
  };

  //권한별메뉴 그리드에 검색한 메뉴 추가
  const handleMenuAuthAdd = () => {
    const menuItem = auiMenuGrid.getSelectedItems()[0].item;
    //console.log(menuItem);
    const authItem = auiAuthGrid.getSelectedItems()[0].item;
    //console.log(authItem);

    var rows = auiMenuAuthGrid.getRowsByValue("menuId", menuItem.menuId);
    //console.log(rows);
    if (rows.length > 0) {
      ModalConfirm({
        title: "메뉴존재",
        description:
          "선택한 메뉴는 그리드에 있습니다. 다시 선택하시기 바랍니다. ",
        type: "alert",
      });
    } else {
      const newData = {
        menuId: menuItem.menuId,
        authId: authItem.authId,
        menuNmKor: menuItem.menuNmKor,
        searchAuthYn: "N",
        saveAuthYn: "N",
        newAuthYn: "N",
        delAuthYn: "N",
        printAuthYn: "N",
        excelAuthYn: "N",
      };
      //console.log(newData);
      auiMenuAuthGrid.addRow(newData, "last");
    }
  };

  //메뉴검색 항목이 변경될때 사용되는 함수
  const handleMenuChangeField = useCallback((event) => {
    const { name, value } = event.target;

    setMenuFieldValues({ ...menuFieldValues, [name]: value });
  });

  return (
    <>
      <ButtonBar
        menuInfo={props.menuInfo}
        handleMasterSearch={handleMasterSearch}
        handleMasterDelete={handleMasterDelete}
        handleMasterSave={handleMasterSave}
      />
      <SearchBar setSearchParameters={setPrimaryParameters} />

      <div className="flexible_contents_box2">
        <div className="databox" style={{ width: "100%", height: "100%" }}>
          <div className="scrollbox">
            <div style={{ width: "100%", height: "100%" }}>
              <div id={authGrid} style={{ width: "100%", height: 600 }} />
            </div>
          </div>
        </div>
        <div className="databox">
          <div className="subdatabox">
            <div id={menuAuthGrid} style={{ height: 300 }} />
            <div className="searchdata">
              <ul className="displays">
                <li style={{ width: "180px" }}>
                  <div style={{ width: "80px" }}>
                    <font color="grey">⦁</font> 메뉴아이디
                  </div>
                  <input
                    type="text"
                    className="datainput"
                    name="schMenuId"
                    style={{ width: "100px" }}
                    onChange={handleMenuChangeField}
                  />
                </li>
                <li style={{ width: "150px" }}>
                  <div style={{ width: "80px" }}>
                    <font color="grey">⦁</font> 메뉴명
                  </div>
                  <input
                    type="text"
                    className="datainput"
                    name="schMenuNmKor"
                    style={{ width: "100px" }}
                    onChange={handleMenuChangeField}
                  />
                </li>
                <li style={{ width: "150px" }}>
                  <button
                    type="button"
                    className="btn_orenge updown0"
                    onClick={handleMenuSearch}
                  >
                    검색
                  </button>
                  <button
                    type="button"
                    className="btn_orenge updown0"
                    onClick={handleMenuAuthAdd}
                  >
                    추가
                  </button>
                </li>
              </ul>
            </div>
            <div id={menuGrid} style={{ height: 250 }} />
          </div>
        </div>
      </div>
    </>
  );
};

export default AuthMenuMng;
